import React from 'react';
import classnames from 'classnames';

import styles from './index.module.scss';

const Growth = () => (
  <div className={classnames(styles.whiteBackground)}>
    <div className={classnames(styles.title)}>Growth so far</div>
    <div className={classnames(styles.subtitle)}>Indorse Code Validators at a glance</div>

    <div className="container ">
      <div className={classnames(styles.growthContainer, 'col-12 px-0 pt-2')}>
        <div className={classnames(styles.info)}>
          <div className={classnames(styles.number)}>250+</div>
          <div className={classnames(styles.text)}>Expert Code Validators</div>
        </div>
        <div className={classnames(styles.info)}>
          <div className={classnames(styles.number)}>15+</div>
          <div className={classnames(styles.text)}>Nationalities</div>
        </div>
        <div className={classnames(styles.info)}>
          <div className={classnames(styles.number)}>
            <span>US$</span>50k+
          </div>
          <div className={classnames(styles.text)}>Earned by expert code validators</div>
        </div>
        <div className={classnames(styles.info)}>
          <div className={classnames(styles.number)}>5k+</div>
          <div className={classnames(styles.text)}>Projects evaluated</div>
        </div>
      </div>
    </div>
  </div>
);

export default Growth;
